export default {
  // 设置 localStorage 数据
  setLocalStorage(key, value) {
    try {
      const stringifiedValue =
        typeof value === "object" ? JSON.stringify(value) : value;
      localStorage.setItem(key, stringifiedValue);
    } catch (error) {
      console.error("设置 localStorage 失败:", error);
    }
  },

  // 获取 localStorage 数据
  getLocalStorage(key) {
    try {
      const value = localStorage.getItem(key);
      return value
        ? value[0] === "{" || value[0] === "["
          ? JSON.parse(value)
          : value
        : null;
    } catch (error) {
      console.error("获取 localStorage 失败:", error);
      return null;
    }
  },

  // 移除 localStorage 数据
  removeLocalStorage(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error("移除 localStorage 失败:", error);
    }
  },

  // 清空 localStorage 数据
  clearLocalStorage() {
    try {
      localStorage.clear();
    } catch (error) {
      console.error("清空 localStorage 失败:", error);
    }
  },

  // 设置 sessionStorage 数据
  setSessionStorage(key, value) {
    try {
      const stringifiedValue =
        typeof value === "object" ? JSON.stringify(value) : value;
      sessionStorage.setItem(key, stringifiedValue);
    } catch (error) {
      console.error("设置 sessionStorage 失败:", error);
    }
  },

  // 获取 sessionStorage 数据
  getSessionStorage(key) {
    try {
      const value = sessionStorage.getItem(key);
      return value
        ? value[0] === "{" || value[0] === "["
          ? JSON.parse(value)
          : value
        : null;
    } catch (error) {
      console.error("获取 sessionStorage 失败:", error);
      return null;
    }
  },

  // 移除 sessionStorage 数据
  removeSessionStorage(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error("移除 sessionStorage 失败:", error);
    }
  },

  // 清空 sessionStorage 数据
  clearSessionStorage() {
    try {
      sessionStorage.clear();
    } catch (error) {
      console.error("清空 sessionStorage 失败:", error);
    }
  },
};
